import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import EmployerHeader from "./EmployerHeader";
import Header from "./Header";
import JobSeekerHeader from "./JobSeekerHeader";

const Index = () => {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage?.getItem("userData"))
  );
  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, []);

  return (
    <>
      {userData?.role === "Company" || userData?.role === "employee" ? (
        <EmployerHeader />
      ) : userData?.role === "JobSeeker" ? (
        <JobSeekerHeader />
      ) : (
        <Header />
      )}
    </>
  );
};
export default withTranslation()(Index);
